<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Update Schema"
            bc1="App"
            bc2="Update Schema"
            bc3="Update"
            path="schemas"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="name"
                                id="name-icon"
                                class="form-control"
                                :class="
                                  errorBag.has('name') ? 'is-invalid' : ''
                                "
                                name="name"
                                placeholder="Name"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('name')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("name") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Currency</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <b-form-select
                                  v-model="currencyId"
                                  name="currencyId"
                                  size="sm"
                                  class=""
                                  v-validate="'required'"
                                  :class="
                                  errorBag.has('currencyId') ? 'is-invalid' : ''
                                "
                              >
                                <b-form-select-option value=""
                                >Please Select Currency
                                </b-form-select-option>
                                <b-form-select-option
                                    v-for="(item, index) in currencyRequestData"
                                    :value="item.id"
                                    :key="index"
                                >{{ item.code }}
                                </b-form-select-option>
                                <b-form-select-option
                                    v-show="
                                    !currencyRequestData
                                  "
                                    value="Please Select Currency"
                                ></b-form-select-option>
                              </b-form-select>
                              <small
                                  v-show="errorBag.has('currencyId')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("currencyId") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="des-icon">Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select class="form-control" v-model="type">
                                <option :key="index" :value="index" v-for="(item, index) in typeList">{{ item }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="des-icon">Description</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <textarea
                                type="text"
                                v-model="description"
                                id="des-icon"
                                class="form-control"
                                name="description"
                                placeholder="Type here ..."
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Smart Routing</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="form-check mt-25">
                              <input class="form-check-input" type="checkbox" id="inlineCheckbox3ds" v-model="smart">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3 d-flex justify-content-end mt-1">
                        <button
                          type="button"
                          class="btn btn-primary mr-1"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

export default {

  mounted() {
    setTimeout(() => {
      this.selectCurrencyData()
    }, 1000);
    var schemaUpdateData = this.$store.getters.getByKey(
        "schemaMainUpdate"
    );
    this.smart = schemaUpdateData.row.smart_routing?true:false
    this.currencyId = schemaUpdateData.row.currency_id
    this.name = schemaUpdateData.row.name
    this.description = schemaUpdateData.row.description
    this.type = schemaUpdateData.row.type ?? 0
    this.id = schemaUpdateData.row.id
    this.index = schemaUpdateData.index;
  },
  data() {
    return {
      name: "",
      description: "",
      type: 0,
      typeList:[
        'Other',
        'CardPayment',
        'Applepay',
        'Googlepay',
      ],
      loading: false,
      size: "10px",
      currencyId: "",
      currencyRequestData: [],
      method:null,
      smart:false,
      id: "",
      index: "",

    };
  },
  methods: {
    selectCurrencyData() {
      this.makeRequest("post", "v1/get-currency", { flag: "active" },{},false).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = [];
                data = callResponse.response.data.data;
                this.currencyRequestData = data
              }
            }
          }
      );
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {



          let data = {
            smartRouting : this.smart?1:0,
            currencyId: this.currencyId,
            name:this.name,
            description:this.description,
            schemaId:this.id,
            type: this.type
          }
          this.loading = true;
          this.makeRequest("post", "v1/update-schema", data).then(
              callResponse => {
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  if (code == 200) {
                    this.loading = false;
                    if (callResponse.response.data.data) {
                      let responseData = callResponse.response.data.data;
                      let storeData = this.$store.getters.getByKey(
                          "schemaMain"
                      );
                      if (storeData != null) {
                        if (typeof storeData.firstPageData != "undefined") {
                          if (
                              typeof storeData.firstPageData.data[this.index] !=
                              "undefined"
                          ) {
                            if (
                                storeData.firstPageData.data[this.index].id == this.id
                            ) {
                              storeData.firstPageData.data[
                                  this.index
                                  ] = responseData;
                              delete storeData.otherPageData;
                            }
                          }
                        }
                        if (typeof storeData.otherPageData != "undefined") {
                          if (
                              typeof storeData.otherPageData.data[this.index] !=
                              "undefined"
                          ) {
                            if (
                                storeData.otherPageData.data[this.index].id == this.id
                            ) {
                              storeData.otherPageData.data[
                                  this.index
                                  ] = responseData;
                            }
                          }
                        }
                        storeData.key = "schemaMain";
                        this.$store.dispatch("set", storeData);
                      }
                      this.$router.push({
                        name: "schema",
                        // params: { update: true }
                      });
                    }
                  }
                }
                this.loading = false;
              }
          );
        }
      });
    }
  },

};
</script>

